import service from './config'
class LoginService {
    Login(param) {
        return service.post('api/TroopsInfo/TroopsLogin',param)
    }
    GetTroopInfo(){
    	return service.get('api/TroopsInfo/GetTroopInfo')
    }
    
}
export default new LoginService()